export default "__VITE_ASSET__BL2TN9qm__"